import { Component, OnInit, ElementRef } from '@angular/core';

@Component({
  selector: 'app-catalogue',
  templateUrl: './catalogue.component.html',
  styleUrls: ['./catalogue.component.less']
})
export class CatalogueComponent implements OnInit {

	list = []

  constructor(private element : ElementRef) { }

  ngOnInit() {
  	const catalogueAnchor = this.element.nativeElement.querySelectorAll('.catalogue-anchor');
  	if(catalogueAnchor.length){
  		for( let i = 0; i < catalogueAnchor.length; i++ ){
  			const title = catalogueAnchor[i].getAttribute('name');
  			const path = catalogueAnchor[i].getAttribute('id');
  			this.list.push({
  				title: title,
  				path: path
  			})
  		}
  	}
  }

	goTo(location: string) {
		const top = document.getElementById(location).offsetTop;
    window.location.hash = location;
    let scroll_top = top - 10;
    window.scrollTo(0, scroll_top);
    return false;
	}

}



// WEBPACK FOOTER //
// ./src/app/component/catalogue/catalogue/catalogue.component.ts